import { render, staticRenderFns } from "./MyReserve.vue?vue&type=template&id=6cf107b4"
import script from "./MyReserve.vue?vue&type=script&lang=ts"
export * from "./MyReserve.vue?vue&type=script&lang=ts"
import style0 from "./MyReserve.vue?vue&type=style&index=0&id=6cf107b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports